export const titleColor = '#07074d';
export const titleBackground = '#e1efff80';
export const textColor = '#373737';
export const buttonBackground = '#00518e';
export const informationText = '#636a75';
export const flBlue = '#1E88E5';
export const textGray = '#5E5E5E';
